// Klaviyo marketing event tracking (frontend → Cloud Functions)
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

interface CartTrackingPayload {
  itemCount: number;
  subtotalCents: number;
  businessId?: string;
  businessName?: string;
  productNames?: string[];
}

let lastTrackedAt = 0;
const DEBOUNCE_MS = 30_000; // avoid spamming Klaviyo on rapid cart edits

export async function trackAddedToCartEvent(payload: CartTrackingPayload): Promise<void> {
  const now = Date.now();
  if (now - lastTrackedAt < DEBOUNCE_MS) return;
  lastTrackedAt = now;

  try {
    const fn = httpsCallable(functions, 'trackAddedToCart');
    await fn(payload);
  } catch (err) {
    // Non-blocking — marketing tracking should never break checkout
    console.warn('[Klaviyo] Cart tracking failed:', err);
  }
}
